import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { KeyboardService } from '../../keyboard/keyboard.service';

@Component({
  selector: 'app-input-percent',
  templateUrl: './input-percent.component.html',
  styleUrls: ['./input-percent.component.sass'],
})
export class InputPercentComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;
  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(public keyboardService: KeyboardService) {}

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.group.get(this.config.name)?.setValue(+event);
    });
  }
}
